import { render, staticRenderFns } from "./noticeFrom.vue?vue&type=template&id=2c95971a&scoped=true&"
import script from "./noticeFrom.vue?vue&type=script&lang=js&"
export * from "./noticeFrom.vue?vue&type=script&lang=js&"
import style0 from "./noticeFrom.vue?vue&type=style&index=0&id=2c95971a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95971a",
  null
  
)

export default component.exports